<div class="lvi-content">
    <div class="avatar">
        <i class="nio icon-profil"></i>
    </div>
    <div class="lvi-body">
        <div class="title">
            <a class="label">{{ data | user:'nomPrenomMatricule' }}</a>
        </div>
        <ul class="lvi-attrs">
            <li *ngIf="data.orga">
                <strong [translate]="'admin.entreprise.utilisateurs.internes.serviceAffectation'"></strong>
                <span>{{ data | user:'orga' }}</span>
            </li>
            <li>
                <strong [translate]="'admin.entreprise.utilisateurs.internes.actif'"></strong>
                <span [translate]="data.actif ? 'global.oui' : 'global.non'"></span>
            </li>
            <li>
                <strong [translate]="'admin.entreprise.utilisateurs.internes.roles'"></strong>
                <span>{{ data?.listeRolesRespBudgetaires?.join(", ") }}</span>
            </li>
        </ul>
    </div>
</div>